<template>
  <modal
    name="live-footage"
    :classes="'customModal'"
    :scrollable="true"
    :reset="true"
    :adaptive="false"
    :width="640"
    height="auto"
    :clickToClose="false"
  >
    <div class="modalWrapper">
      <div class="form-row">
        <div class="col-sm-12">
          <div class="content__box">
            <div class="content__box__body">
              <div
                class="top__filter mb-1"
                v-for="laneDevice in laneDevices"
                :key="laneDevice.device_uuid.toLowerCase()"
              >
                <ul class="top__filter__ul">
                  <li>
                    {{ (laneDevice || {}).device_name || "N/A" }} 
                    <span v-if="['e4ce72fe5323de0f342fa3c05a34698b', '98473db035daf55fc6ae884142146e9d', 'd7899fc9b1caf5b05dddebb2277ecbd8', 'e52708f3cc7173ccb2b837b67737e796', '171a48f3e24599ff5e6cdd0091b555eb', '467c96c31cd3eef0ed76a5d3ae39f5a2', '54627b3bb50c6de7bd8b3ba2d3f00d2b'].includes(laneDevice.device_uuid.toLowerCase())" class="txt--primary font-weight-bold" @click="showKioskScreenshot($event, laneDevice)">
                      View
                    </span>
                  </li>
                </ul>
                  
                <ul class="top__filter__ul">
                  <li class="txt--primary opacity--1" @click="triggerGate(laneDevice, 'relay')">
                    Pulse
                  </li>
                  <li class="txt--primary opacity--1" @click="triggerGate(laneDevice, 'relay', 'on')">
                    Open
                  </li>
                  <li class="txt--primary opacity--1" @click="triggerGate(laneDevice, 'relay', 'off')">
                    Close
                  </li>
                  <!-- <li class="txt--primary opacity--1" @click="triggerGate(laneDevice, 'alpr')">
                    Trigger ALPR
                  </li> -->
                </ul>
              </div>
              <!-- <div class="liveFootage">
                <img
                  src="@/assets/images/liveFootageEntryFront.png"
                  alt="Image"
                />
              </div> -->
            </div>
          </div>
        </div>
        <!-- <div class="col-sm-6 mb-2">
          <div class="content__box">
            <div class="content__box__body">
              <div class="top__filter mb-1">
                <ul class="top__filter__ul">
                  <li>Exit</li>
                </ul>
                <ul class="top__filter__ul">
                  <li class="txt--primary opacity--1" @click="openGate()">
                    Open Gate
                  </li>
                </ul>
              </div>
              <div class="liveFootage">
                <img
                  src="@/assets/images/liveFootageEntryBack.png"
                  alt="Image"
                />
              </div>
            </div>
          </div>
        </div> -->
        <!-- <div class="col-sm-6">
          <div class="content__box">
            <div class="content__box__body">
              <div class="top__filter mb-1">
                <ul class="top__filter__ul">
                  <li>Exit (Front)</li>
                </ul>
              </div>
              <div class="liveFootage">
                <img
                  src="@/assets/images/liveFootageExitFront.png"
                  alt="Image"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="col-sm-6">
          <div class="content__box">
            <div class="content__box__body">
              <div class="top__filter mb-1">
                <ul class="top__filter__ul">
                  <li>Exit (Back)</li>
                </ul>
              </div>
              <div class="liveFootage">
                <img
                  src="@/assets/images/liveFootageExitBack.png"
                  alt="Image"
                />
              </div>
            </div>
          </div>
        </div> -->
      </div>
      <div class="session__modal__close" @click="closeModal()">
        <i class="fas fa-times"></i>
      </div>
    </div>
  </modal>
</template>

<script>
export default {
  props: ["space_id", "laneDevices", "selectedLaneDevice"],
  data() {
    return {
      baseUrl: "https://pied-iot-prod.firebaseio.com",
    };
  },
  computed: {
    computeModalWidth() {
      if (this.$mq === "lg") return "900px";
      else return "400px";
    },
  },
  methods: {
    closeModal() {
      this.$modal.hide("live-footage");
    },
    async showKioskScreenshot(event, laneDevice) {
      try {
        const labelElement = event.currentTarget;

        // Initial fetch + display
        await this._updateScreenshot(labelElement, laneDevice);

        // Setup polling while popover is open
        if (this._screenshotInterval) {
          clearInterval(this._screenshotInterval);
        }

        this._screenshotInterval = setInterval(() => {
          this._updateScreenshot(labelElement, laneDevice);
        }, 2000);
      } catch (err) {
        console.error(err);
      }
    },

    async _updateScreenshot(labelElement, laneDevice) {
      try {
        await fetch(`${this.baseUrl}/propertyDeviceKioskControls/${this.space_id}/${laneDevice.device_uuid.toLowerCase()}/publishScreenshotTimestamp.json`, {
          method: 'PUT',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(Date.now())
        });

        await new Promise(resolve => setTimeout(resolve, 1000));

        const dataUri = await fetch(`${this.baseUrl}/propertyDeviceKioskScreenshot/${this.space_id}/${laneDevice.device_uuid.toLowerCase()}.json`)
          .then(r => r.json());

        this._showPopover(labelElement, laneDevice, dataUri);
      } catch (err) {
        console.error(err);
      }
    },

    async forceCrashKiosk(laneDevice) {
      // TODO: Implement the logic to force crash the kiosk
    },

    _showPopover(anchorEl, laneDevice, imageDataUri) {
      // Remove existing popover
      document.querySelectorAll('.popover').forEach(el => el.remove());

      const popover = document.createElement('div');
      popover.className = 'popover';
      popover.style.position = 'absolute';
      popover.style.border = '1px solid #ccc';
      popover.style.background = '#fff';
      popover.style.padding = '8px';
      popover.style.boxShadow = '0 2px 8px rgba(0,0,0,0.3)';
      popover.style.zIndex = 1000;

      const rect = anchorEl.getBoundingClientRect();
      popover.style.left = `${rect.right + 10}px`;
      popover.style.top = `${rect.top}px`;

      // Close button
      const closeButton = document.createElement('div');
      closeButton.innerText = '×';
      closeButton.style.position = 'absolute';
      closeButton.style.top = '4px';
      closeButton.style.right = '4px';
      closeButton.style.width = '24px';
      closeButton.style.height = '24px';
      closeButton.style.lineHeight = '24px';
      closeButton.style.textAlign = 'center';
      closeButton.style.borderRadius = '50%';
      closeButton.style.background = 'rgba(0, 0, 0, 0.5)';
      closeButton.style.color = '#fff';
      closeButton.style.cursor = 'pointer';
      closeButton.style.fontSize = '16px';
      closeButton.style.fontWeight = 'bold';

      closeButton.addEventListener('click', () => {
        clearInterval(this._screenshotInterval);
        this._screenshotInterval = null;
        popover.remove();
      });

      // Restart Kiosk button
      const restartButton = document.createElement('div');
      restartButton.innerText = 'Restart Kiosk';
      restartButton.style.position = 'absolute';
      restartButton.style.bottom = '8px';
      restartButton.style.right = '8px';
      restartButton.style.padding = '6px 12px';
      restartButton.style.borderRadius = '20px';
      restartButton.style.background = 'rgba(0, 0, 0, 0.5)';
      restartButton.style.color = '#fff';
      restartButton.style.cursor = 'pointer';
      restartButton.style.fontSize = '14px';
      restartButton.style.fontWeight = 'bold';
      restartButton.style.boxShadow = '0 2px 4px rgba(0,0,0,0.2)';

      restartButton.addEventListener('click', () => {
        this.forceCrashKiosk(laneDevice);
      });

      const img = document.createElement('img');
      img.src = imageDataUri;
      img.style.maxWidth = '180px';
      img.style.maxHeight = '540px';

      popover.appendChild(closeButton);
      popover.appendChild(img);
      // popover.appendChild(restartButton);
      document.body.appendChild(popover);
    },
    triggerGate(laneDevice, mode, relayMode = 'once') {
      this.$swal({
        title: "",
        html: `<p class="txt--ss font-weight-bold txt--off-white" >Are you sure you want to trigger this gate?</p>`,
        confirmButtonText: "Trigger",
        showCancelButton: true,
      }).then((result) => {
        if (!result) {
            return;
        }

        this.axios.post(window.hostname + "api/auth/trigger-gate", {
            mode: mode,
            relay_mode: relayMode,
            space_id: this.space_id,
            device_uuid: laneDevice.device_uuid,
            // license_plate: this.license_plate,
        }).then(res => {
            console.log(res.data);
            
            if (res.data.status) {
                this.name = res.data.data;
                this.$toasted.show(res.data.message, {
                    icon : 'check-circle',
                    className :'success-class'
                });
                // this.closeModal();
            } else {
                this.$toasted.show(res.data.message, {
                    icon: 'times-circle',
                    className: 'error-class'
                });
            }
        }).catch(error => {
            console.error(error);
            
            this.$toasted.show(error.message || 'Something went wrong!', {
                icon: 'times-circle',
                className: 'error-class'
            });
        });
      });
    },
  },
};
</script>

<style>
.vm--overlay {
  background: rgba(0, 0, 0, 0.9) !important;
}
</style>
